import type { ILanguageResources, ITranslationModule } from '../../../../interfaces';
import { interpolate } from '../../../../global';

class Id {
  private constructor() {}
  public static readonly prefix = 'UI.scripts.dealer-franchisee.dashboard.widget.BranchMonthlyRevenue.';
  public static readonly monthlyGeneratedRevenue = `${Id.prefix}monthlyGeneratedRevenue`;
}

export class LangDashboardBranchMonthlyRevenue {
  private constructor() {}
  public static monthlyGeneratedRevenue(): string {
    return interpolate(Id.monthlyGeneratedRevenue);
  }
}

export class DashboardBranchMonthlyRevenueModule implements ITranslationModule {
  registerItems(register: ILanguageResources) {
    register.add(
      Id.monthlyGeneratedRevenue,
      'Monthly Generated Revenue',
      'Header for monthly generated revenue widget'
    );
  }
}
